import { render, staticRenderFns } from "./TikQModalOverlay.vue?vue&type=template&id=16c3fcc4&scoped=true&"
import script from "./TikQModalOverlay.vue?vue&type=script&lang=js&"
export * from "./TikQModalOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TikQModalOverlay.vue?vue&type=style&index=0&id=16c3fcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3fcc4",
  null
  
)

export default component.exports